import styled from 'styled-components';
export const Wrapper = styled.div ``;
export const Background = styled.picture `
  border-top-left-radius: var(--border-radius-lg);
  border-top-right-radius: var(--border-radius-lg);
  overflow: hidden;
  
  img {
    aspect-ratio: 355 / 133;
    width: 100%;
  }
`;
export const SmallPrint = styled.div `
  line-height: 1.17;
  
  small {
    margin-bottom: 0;
  }
`;
export default {
    Wrapper,
    Background,
    SmallPrint,
};
